// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-sticky-nav{bottom:0}.mobile-sticky-nav iframe{height:700px;-ms-scroll-chaining:none;overscroll-behavior:contain}", ""]);
// Exports
module.exports = exports;
